import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import LinearGradient from "react-native-linear-gradient";
import { CrateSummary, ReturnSummary } from "../utils";

interface HeaderCardProps {
  summary: ReturnSummary | CrateSummary;
}
const HeaderCard: React.FC<HeaderCardProps> = ({ summary }) => {
  return (
    <LinearGradient
      colors={["#FFECEC", "#FFFBFB"]}
      start={{ x: 0.0378, y: 0.5 }}
      end={{ x: 0.9404, y: 0.5 }}
      style={styles.container}
    >
      <View style={styles.mainSection}>
        <View style={styles.row}>
          <Text variant="title_16" style={styles.title}>
            {summary?.title}
          </Text>
          <View style={styles.quantityContainer}>
            <Text variant="caption_2" style={styles.label}>
              {`Qty. `}
            </Text>
            <Text variant="title_16" style={styles.quantity}>
              {summary?.qty}
            </Text>
          </View>
        </View>
        {summary?.subtitle ? (
          <View style={styles.row}>
            <Text variant="caption_2" style={styles.label}>
              {summary?.subtitle}
            </Text>
            <Text variant="caption_2" style={styles.amount}>
              {summary?.price}
            </Text>
          </View>
        ) : null}
      </View>
      {summary?.list?.map((subHeader) => (
        <View style={styles.subSection} key={subHeader.title}>
          <View style={styles.row}>
            <Text variant="caption_2" style={styles.subTitle}>
              {subHeader.title}
            </Text>
            <View style={styles.quantityContainer}>
              <Text variant="caption_2" style={styles.label}>
                {`Qty. `}
              </Text>
              <Text variant="caption_4" style={styles.quantity}>
                {subHeader.qty}
              </Text>
            </View>
          </View>
          {subHeader.subtitle ? (
            <View style={styles.row}>
              <Text variant="caption_2" style={styles.subTitle}>
                {subHeader.subtitle}
              </Text>
              <Text variant="caption_4" style={styles.amount}>
                {subHeader.price}
              </Text>
            </View>
          ) : null}
        </View>
      ))}
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    padding: 12,
    borderColor: "rgba(255, 218, 218, 1)",
    borderWidth: 2,
  },
  mainSection: {},
  subSection: {
    marginTop: 10,
    backgroundColor: color.white,
    borderRadius: 12,
    padding: 12,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "baseline",
  },
  title: {
    color: color.mediumBlack,
  },
  subTitle: {
    fontWeight: "500",
    color: color.mediumBlack,
    flex: 1,
  },
  quantityContainer: {
    flexDirection: "row",
    alignItems: "baseline",
  },
  label: {
    color: color.mediumBlacklightBlack,
  },
  quantity: {
    color: color.mediumBlack,
  },
  amount: {
    color: color.mediumBlack,
    lineHeight: 18,
  },
});

export default HeaderCard;
